import * as React from "react"

export const NoEntryYetIcon = () => {
  return (
    <svg width="180" height="151" viewBox="0 0 180 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="180" height="150" transform="translate(0 0.5)" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M111.55 14.7999C85.4668 10.5388 88.1261 53.1918 53.4208 47.3539C17.9231 41.3827 7.31346 83.5059 17.9231 106.773C29.382 131.903 102.756 145.413 129.007 126.888C158.551 106.038 160.489 22.7948 111.55 14.7999Z"
        fill="#E3EBF5"
      />
      <path
        d="M41 103.5L61 84.5H119L139 103.5V131.5C139 134.261 136.761 136.5 134 136.5H46C43.2386 136.5 41 134.261 41 131.5V103.5Z"
        stroke="#A8A8A8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M41 103.5L61 84.5H119L139 103.5V131.5C139 134.261 136.761 136.5 134 136.5H46C43.2386 136.5 41 134.261 41 131.5V103.5Z"
        fill="white"
        stroke="#161819"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66 103.5H41V131.5C41 134.261 43.2386 136.5 46 136.5H134C136.761 136.5 139 134.261 139 131.5V103.5H114C114 109.575 109.075 114.5 103 114.5H77C70.9249 114.5 66 109.575 66 103.5Z"
        fill="white"
      />
      <path
        d="M41 103.5V103C40.7239 103 40.5 103.224 40.5 103.5H41ZM66 103.5H66.5C66.5 103.224 66.2761 103 66 103V103.5ZM139 103.5H139.5C139.5 103.224 139.276 103 139 103V103.5ZM114 103.5V103C113.724 103 113.5 103.224 113.5 103.5H114ZM41 104H66V103H41V104ZM41.5 131.5V103.5H40.5V131.5H41.5ZM46 136C43.5147 136 41.5 133.985 41.5 131.5H40.5C40.5 134.538 42.9624 137 46 137V136ZM134 136H46V137H134V136ZM138.5 131.5C138.5 133.985 136.485 136 134 136V137C137.038 137 139.5 134.538 139.5 131.5H138.5ZM138.5 103.5V131.5H139.5V103.5H138.5ZM114 104H139V103H114V104ZM113.5 103.5C113.5 109.299 108.799 114 103 114V115C109.351 115 114.5 109.851 114.5 103.5H113.5ZM103 114H77V115H103V114ZM77 114C71.201 114 66.5 109.299 66.5 103.5H65.5C65.5 109.851 70.6487 115 77 115V114Z"
        fill="#161819"
      />
      <path
        d="M91 95.4224C99.7155 93.9502 104.888 85.0105 108.4 78.1628C112.673 69.8318 115.761 61.6417 115.263 52.3755C114.818 44.1177 103.304 40.2607 97.075 46.5317C93.4289 50.2022 91.0626 54.97 91.75 59.952C92.5025 65.4059 98.5412 69.4257 103.15 72.1832C120.086 82.3164 137.621 67.2073 145 53.8364"
        stroke="#161819"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="4 5"
      />
      <path
        d="M41.343 34.2485C39.0783 27.549 48.5314 25.786 54.9496 21.2022C63.6784 13.4449 66.5002 12.8967 68.8107 17.1279C71.1213 21.3591 70.3533 30.0172 63.9351 35.3063C57.5169 40.5953 44.6804 44.1213 41.343 34.2485Z"
        fill="#E3EBF5"
      />
      <g clip-path="url(#clip0_401_1294)">
        <path
          d="M146.309 41.7054C146.295 41.7069 146.278 41.7119 146.26 41.7105C144.725 41.9019 143.618 43.311 143.788 44.8491C143.87 45.5828 144.224 46.2385 144.798 46.7022C145.718 47.4449 146.696 47.4167 147.712 47.1034L152.851 40.7432C153.181 38.9143 153.103 37.2811 151.655 36.1116C150.882 35.4863 149.902 35.2104 148.905 35.3338C146.89 35.5832 145.425 37.4347 145.648 39.4602C145.712 40.0722 145.958 40.8876 146.308 41.7054L146.309 41.7054ZM149.065 37.1678C149.547 37.1062 150.019 37.239 150.392 37.5336C151.169 38.1618 151.289 39.2899 150.675 40.0659C150.057 40.8461 148.925 40.9871 148.149 40.3799L148.134 40.3674C147.371 39.7517 147.255 38.6201 147.866 37.8476C148.167 37.4672 148.592 37.2251 149.065 37.1678L149.065 37.1678Z"
          fill="#3E92D2"
        />
        <path
          d="M148.756 39.5956L148.763 39.6009C149.108 39.8739 149.619 39.8071 149.899 39.4519C150.177 39.1007 150.126 38.5923 149.787 38.3186C149.614 38.1814 149.404 38.1236 149.192 38.1506C148.975 38.1774 148.781 38.2883 148.645 38.4612C148.366 38.8119 148.417 39.3214 148.756 39.5956L148.756 39.5956Z"
          fill="#3E92D2"
        />
        <path
          d="M159.028 45.1194C158.676 44.8406 158.166 44.9078 157.885 45.2626C157.608 45.6138 157.658 46.1222 157.997 46.3959L158.004 46.4016C158.351 46.6756 158.86 46.6079 159.141 46.2532C159.419 45.9031 159.368 45.3941 159.028 45.1194L159.028 45.1194Z"
          fill="#3E92D2"
        />
        <path
          d="M160.834 42.8673C159.402 41.7099 157.848 41.9561 156.165 42.6523L151.011 49.0316C150.901 50.146 151.065 51.1431 152.01 51.907C152.599 52.3828 153.347 52.5923 154.103 52.4909C155.635 52.3031 156.745 50.8974 156.579 49.3557C156.577 49.3417 156.576 49.3277 156.574 49.3137C157.446 49.4639 158.299 49.5105 158.91 49.4314C160.928 49.1784 162.385 47.3271 162.167 45.3055C162.057 44.3391 161.585 43.4738 160.834 42.8673L160.834 42.8673ZM157.389 47.1792L157.373 47.1667C156.615 46.5539 156.495 45.4258 157.109 44.6498C157.73 43.8659 158.859 43.7286 159.635 44.3357C160.409 44.9611 160.532 46.092 159.918 46.8681C159.297 47.6519 158.165 47.7934 157.389 47.1792L157.389 47.1792Z"
          fill="#3E92D2"
        />
        <path
          d="M156.129 40.8775C156.301 40.6649 156.155 40.2616 155.801 39.9759C155.449 39.6909 155.023 39.6315 154.851 39.8447L148.007 48.3149C147.836 48.5274 147.982 48.9307 148.335 49.2165C149.56 50.2048 149.366 48.7168 156.129 40.8774L156.129 40.8775Z"
          fill="#3E92D2"
        />
      </g>
      <defs>
        <clipPath id="clip0_401_1294">
          <rect width="19.5944" height="19.5944" fill="white" transform="translate(150.392 30.5) rotate(38.9367)" />
        </clipPath>
      </defs>
    </svg>
  )
}
